import { Field, inputClass } from "./Field.js";

export function SkuDivisibilityFields({
  isDivisible,
  qtyStep,
  onChange,
}: {
  isDivisible: boolean;
  qtyStep: string;
  onChange: (next: { isDivisible: boolean; qtyStep: string }) => void;
}) {
  return (
    <>
      <div className="mb-4 rounded-lg border border-stone-200 bg-stone-50 p-3">
        <label htmlFor="isDivisible" className="flex items-start gap-3">
          <input
            id="isDivisible"
            type="checkbox"
            className="mt-1 h-5 w-5 shrink-0"
            checked={isDivisible}
            onChange={(e) => onChange({ isDivisible: e.target.checked, qtyStep: e.target.checked ? "0.5" : "1" })}
          />
          <span className="text-sm">
            <span className="block font-medium text-stone-800">무게 단위로 주문받기 (lb, kg 등)</span>
            <span className="block text-stone-500">
              체크하면 소수점 수량(예: 0.5 lb씩)을 받을 수 있습니다. 체크하지 않으면 박스·개처럼 정수 단위로만
              주문받습니다.
            </span>
          </span>
        </label>
      </div>
      <Field
        label={isDivisible ? "주문 단위 (예: 0.5 lb씩 주문)" : "주문 단위 (박스 단위, 정수만)"}
        htmlFor="qtyStep"
      >
        <input
          id="qtyStep"
          inputMode="decimal"
          required
          className={inputClass}
          value={qtyStep}
          onChange={(e) => onChange({ isDivisible, qtyStep: e.target.value })}
        />
      </Field>
    </>
  );
}
